import { render, staticRenderFns } from "./TreasurytoBranch.vue?vue&type=template&id=428f6bc8&scoped=true"
import script from "./TreasurytoBranch.vue?vue&type=script&lang=js"
export * from "./TreasurytoBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428f6bc8",
  null
  
)

export default component.exports